import { useContext } from "react";
import { NotifierContext } from "App/Notifier";

export function useNotification() {
  return useContext(NotifierContext).showNotification
}